import React, { useState, useEffect } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import { deepOrange } from "@material-ui/core/colors";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import swal from "sweetalert";
import { Box } from "@material-ui/core";
import axios from "axios";
import { DELETE_MESSAGE_DATA } from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

// import { deleteMessageData } from "../../../Dashboard/StartupDashboard/dependencies/action";

import clsx from "clsx";
const useStyles = makeStyles((theme) =>
  createStyles({
    messageRow: {
      display: "flex",
      marginTop: "20px",
    },
    messageRowRight: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "20px",
    },
    messageBlue: {
      position: "relative",
      marginLeft: "20px",
      marginBottom: "10px",
      padding: "10px",
      backgroundColor: "#b499c7",
      maxWidth: "60%",
      //height: "50px",
      textAlign: "left",
      font: "400 .9em 'Open Sans', sans-serif",
      border: "1px solid #b499c7",
      borderRadius: "10px",
      "&:after": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "15px solid #b499c7",
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        top: "0",
        left: "-15px",
      },
      "&:before": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "17px solid #b499c7",
        borderLeft: "16px solid transparent",
        borderRight: "16px solid transparent",
        top: "-1px",
        left: "-17px",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "18px !important",
      },
    },
    messageOrange: {
      position: "relative",
      marginRight: "20px",
      marginBottom: "10px",
      padding: "10px",
      paddingRight: "30px",
      maxWidth: "60%",
      backgroundColor: "#c6cbd4",
      textAlign: "left",
      font: "400 .9em 'Open Sans', sans-serif",
      border: "1px solid #c6cbd4",
      borderRadius: "10px",
      "&:after": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "15px solid #c6cbd4",
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        top: "0",
        right: "-15px",
      },
      "&:before": {
        content: "''",
        position: "absolute",
        width: "0",
        height: "0",
        borderTop: "17px solid #c6cbd4",
        borderLeft: "16px solid transparent",
        borderRight: "16px solid transparent",
        top: "-1px",
        right: "-17px",
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "18px !important",
      },
    },

    messageContent: {
      padding: 0,
      margin: 0,
      whiteSpace: "pre-line",
      wordBreak: "break-word",
      [theme.breakpoints.down("md")]: {
        fontSize: "18px !important",
      },
    },
    messageTimeStampRight: {
      position: "absolute",
      fontSize: "14px",
      fontFamily: "Montserrat",
      fontWeight: "300",
      marginTop: "10px",
      bottom: "-18px",
      right: "5px",
      width: "max-content",
    },
    messageTimeStampLeft: {
      position: "absolute",
      fontSize: "14px",
      fontFamily: "Montserrat",
      fontWeight: "300",
      marginTop: "10px",
      bottom: "-18px",
      left: "5px",
      width: "max-content",
    },

    orange: {
      color: theme.palette.getContrastText(deepOrange[500]),
      backgroundColor: deepOrange[500],
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    avatarNothing: {
      color: "transparent",
      backgroundColor: "transparent",
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    displayName: {
      marginLeft: "20px",
      fontSize: "14px",
      fontFamily: "Montserrat",
      textAlign: "start",
    },
    messageDate: {},
  })
);

export const MessageLeft = (props) => {
  const messagedelete = props.messagedelete;
  const message = props.message;
  const timestamp = props.timestamp;
  const name = props.name;
  const classes = useStyles();
  return (
    <>
      <div className={classes.messageRow}>
        <div className={classes.messageBlue}>
          <div>
            <span
              style={{
                fontSize: "16px",
                lineHeight: "25px",
                color: "white",
              }}
            >
              {name}
            </span>
            <p className={classes.messageContent}>
              {message && message === "You deleted this message"
                ? "this message is deleted"
                : message}
            </p>
            {messagedelete === false ? (
              <div>
                {props?.image &&
                  (props?.imageType?.includes("image") ? (
                    <img
                      style={{
                        height: "140px",
                        width: "140px",
                        marginBottom: "20px",
                      }}
                      src={`${process.env.REACT_APP_DOC_URL}${props?.image}`}
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_DOC_URL}${props?.image}`,
                          "_blank"
                        )
                      }
                    />
                  ) : (
                    <Box
                      style={{
                        height: "60px",
                        width: "140px",
                        marginBottom: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "14px",
                        color: "blue",
                        textDecoration: "underline",
                        whiteSpace: "pre-line",
                        wordBreak: "break-word",
                      }}
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_DOC_URL}${props?.image}`,
                          "_blank"
                        )
                      }
                    >
                      View Attachment
                    </Box>
                  ))}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className={classes.messageTimeStampLeft}>{timestamp}</div>
        </div>
      </div>
    </>
  );
};

export const MessageRight = (props) => {
  const LoginUser = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const deleteapiCall = () => {
    // axios({
    //   url: DELETE_MESSAGE_DATA,
    //   method: "post",
    //   data: {
    //     id: messageId,
    //     senderId: LoginUser?.id,
    //   },
    // })
    api
      .POST(DELETE_MESSAGE_DATA, {
        id: messageId,
        senderId: LoginUser?.id,
      })
      .then((res) => {
        if (res.status == 200) {
          //   setTimeout(() => {
          //   swal("Your Message has been deleted!", {
          //     icon: "success",
          //   });
          // }, 500);
        } else {
          swal("Delete operation unsuccessfull");
        }
      });
  };

  const handleDelete = () => {
    swal("Are you sure?", "Do you want to delete this message?", {
      icon: "warning",
      buttons: {
        delete: {
          text: "OK",
        },
        decline: {
          text: "CANCEL",
        },
      },
    })
      .then((value) => {
        if (value === "delete") {
          deleteapiCall();
        } else {
          swal("Delete operation cancelled");
        }
      })

      .catch((err) => {});
  };

  const classes = useStyles();
  const messagedelete = props.messagedelete;
  const messageId = props.messageId;
  const message = props.message;
  const timestamp = props.timestamp;

  return (
    <>
      <div className={classes.messageRowRight}>
        <div className={clsx(classes.messageOrange, "deletepopup")}>
          <p className={classes.messageContent}>{message}</p>
          {messagedelete === false ? (
            <div>
              {props?.image &&
                (props?.imageType?.includes("image") ? (
                  <img
                    style={{
                      height: "140px",
                      width: "140px",
                      marginBottom: "20px",
                    }}
                    src={`${process.env.REACT_APP_DOC_URL}${props?.image}`}
                    onClick={() =>
                      window.open(
                        `${process.env.REACT_APP_DOC_URL}${props?.image}`,
                        "_blank"
                      )
                    }
                  />
                ) : (
                  <Box
                    style={{
                      height: "60px",
                      width: "140px",
                      marginBottom: "20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "blue",
                      textDecoration: "underline",
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                    }}
                    onClick={() =>
                      window.open(
                        `${process.env.REACT_APP_DOC_URL}${props?.image}`,
                        "_blank"
                      )
                    }
                  >
                    View Attachment
                  </Box>
                ))}
            </div>
          ) : (
            ""
          )}

          {messagedelete === false ? (
            <DeleteIcon
              className="showbelowdata"
              onClick={() => handleDelete()}
            />
          ) : (
            ""
          )}

          <div className={classes.messageTimeStampRight}>{timestamp}</div>
        </div>
      </div>
    </>
  );
};
